/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const meetingStandupActionsDemoContent = [
  { type: 'heading', level: 2, text: 'Action items' },
  {
    type: 'checklist',
    items: [
      { text: 'Jordan — inbox briefing layout wireframes by Wednesday', checked: false },
      { text: 'Sam — avatar scene export @2x for home', checked: false },
      { text: 'You — share standup recap in #mission-control', checked: false },
    ],
  },
  {
    type: 'quote',
    text: 'Sia summary: team is aligned on shipping Mission Control notes before inbox v2; risk is calendar integration scope creep.',
  },
]
